var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"zc-calendario w-100 overflow-auto scroll-old fadeIn"},[_c('div',{staticClass:"col-11"},[_c('FullCalendar',{staticClass:"fullcalendar-styles",attrs:{"options":_vm.calendarOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }